import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';

const useTotalAccumulatedVoSpool = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error, mutate } = useSWR(
        interfaceSDK ? 'totalAccumnulatedVoSpool' : null,
        () => interfaceSDK!.get.getTotalAccumulatedVoSpool()
    );

    const update = async (previousValue?: string) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (currentValue !== previousValue) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);
    };

    return {
        totalAccumulatedVoSpool: data,
        isLoading: !error && !data,
        error,
        updateTotalAccumulatedVoSpool: update,
    };
};

export default useTotalAccumulatedVoSpool;
